var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LegendEntry from './entry';
import LegendHeader from './header';
const Legend = (_a) => {
    var { title, entries, size, headerProps, entryProps, rectProps, onEntryClick } = _a, props = __rest(_a, ["title", "entries", "size", "headerProps", "entryProps", "rectProps", "onEntryClick"]);
    const itemHeight = size.height / (entries.length + 1);
    return (React.createElement("g", Object.assign({}, props),
        React.createElement("rect", Object.assign({ width: size.width, height: size.height, stroke: "#aaaaaa", strokeWidth: "1px", fill: "none", vectorEffect: "non-scaling-stroke", shapeRendering: "crispEdges" }, rectProps)),
        React.createElement(LegendHeader, Object.assign({ text: title, size: { width: size.width, height: itemHeight } }, headerProps)),
        entries.map((entry, i) => (React.createElement(LegendEntry, Object.assign({ key: i, label: entry, size: { width: size.width, height: itemHeight }, transform: `translate(0,${itemHeight * (i + 1)})`, onClick: () => onEntryClick && onEntryClick(i) }, entryProps))))));
};
export default Legend;
